// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = (lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||alias2).call(alias1,"timeout.modal.message","<strong id='idle-timeout-countdown'></strong>",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":3},"end":{"line":1,"column":85}}})) != null ? stack1 : "")
    + "</p>\n<p>"
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||alias2).call(alias1,"timeout.modal.question",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":2,"column":3},"end":{"line":2,"column":36}}}))
    + "</p>\n";
},"useData":true});
